import Image from "next/image";
import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";

const ImageBadges = () => {
  const { product } = useProductDetail();

  const hasBanners =
    product?.product_banners && product.product_banners.length > 0;
  const hasBadges = product?.badges && product.badges.length > 0;

  if (!hasBanners && !hasBadges) return null;

  return (
    <div
      className="absolute top-2 left-2 z-50 flex flex-col gap-1.5 pointer-events-none"
      style={{ animation: "imageBadgesIn 0.5s ease 0.2s both" }}
    >
      {hasBanners &&
        product.product_banners.map((banner, i) => (
          <div
            key={`banner-${i}`}
            className="relative w-12 h-12 rounded overflow-hidden"
            style={{ animation: `imageBadgeItem 0.3s ease ${0.1 * i}s both` }}
          >
            <Image
              src={banner}
              alt={`Banner ${i + 1}`}
              fill
              className="object-contain"
              sizes="48px"
            />
          </div>
        ))}
    </div>
  );
};

export default ImageBadges;